import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR_TEXT_PRIMARY, COLOR_TEXT_SECONDARY } from '../colors/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  text-align: center;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
`;

const Icon = styled.img`
  width: 64px;
  height: 64px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${COLOR_TEXT_PRIMARY};
  margin: 0;
`;

const Description = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${COLOR_TEXT_SECONDARY};
  line-height: 1.4;
  margin: 0;
`;

const renderIcon = (icon, iconSrc, iconAlt) => {
  if (icon) return icon;
  if (!iconSrc) return null;
  return (
    <Icon
      src={iconSrc}
      alt={iconAlt}
      aria-hidden={iconAlt === ''}
      data-testid="you-back-to-original-device-icon"
    />
  );
};

export const YouBackToOriginalDevice = ({
  title,
  description,
  iconSrc,
  icon,
  iconAlt = '',
}) => (
  <Container
    data-testid="you-back-to-original-device"
    role="status"
    aria-live="polite"
  >
    {renderIcon(icon, iconSrc, iconAlt)}
    <Title data-testid="you-back-to-original-device-title">{title}</Title>
    <Description data-testid="you-back-to-original-device-description">
      {description}
    </Description>
  </Container>
);

YouBackToOriginalDevice.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  iconSrc: PropTypes.string,
  icon: PropTypes.node,
  iconAlt: PropTypes.string,
};

export default YouBackToOriginalDevice;
